import BarracksToolbar from "./BarracksToolbar";

export default BarracksToolbar;
